import React from 'react';
import cn from 'classnames';
import {IconProps} from './IconProps';

export default function IconSelectChevron({className, height}: IconProps) {
  return (
    <svg
      className={cn(className, 'h-5 w-5')}
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      height={height}
    >
      <path
        d="M7 7l3-3 3 3m0 6l-3 3-3-3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
